import axios from "axios";
import config from "../config"
import { history } from "../store";
import { getJsonCookies } from '../helpers/utility'
const customHeader = () => ({
    'x-access-token': getJsonCookies() || undefined,
  });
export function api(server) {
    let opts = {
        baseURL: server ? config.server : config.api.trim(),
        headers: getJsonCookies() ?  customHeader() : null
    };
    return axios.create(opts);
}

export function dashboardApi() {
    let opts = {
        baseURL: config.dashboardApi.trim(),
        headers: getJsonCookies() ?  customHeader() : null
    };
    return axios.create(opts);
}
export function catchHandler(e) {
    let res = e.response && e.response.data ? e.response.data : { message: "Oops! Something went wrong, please try again later" };
    if (getJsonCookies() && e.response && e.response.status === 401) {
        history.push("/login");
    }
    throw res
}

export function catchHandlerForPaymentIntent (e) {
    if (e && e === 401) {
      history.push('/login')
    }
    throw e
  }